// @ts-expect-error
import onecolor from 'onecolor';

function parseDOMColor(value: string): string | null {
  if (!value) {
    return null;
  }
  const color = onecolor(value);
  if (!color) {
    // onecolor returns false if it could not parse the value.
    return null;
  }
  if (color.alpha() === 0) {
    // treat completely transparent as null
    return null;
  }
  return color.hex().toUpperCase();
}

export default parseDOMColor;
